module.exports = __webpack_public_path__ + "static/media/0327_IMG_LE_SOL_MEGALITH_MEGABLACK.b5a86bc3.png";